import React from "react";

function Hero() {
  return (
    <section className="text-white bg-[url('./img/banner-3.jpg')] bg-cover bg-center bg-no-repeat min-h-[420px] md:min-h-[480px] flex flex-col justify-center items-center space-y-8 py-14">
      <h3 className="text-2xl font-semibold">OUR STORY</h3>
        <p className="px-5 xl:w-[60%] text-center leading-tight text-xl">
        Discoverloan’s genesis can be traced to 2019, when it was co founded by the few experienced banker with more than 10 years experiences.At Discoverloan we’re committed to providing finance advisory services that you can trust. We provide honest advice, informed by experience, designed for you.
        </p>
    </section>
  );
}

export default Hero;
